export default () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2715_6682)">
            <rect width="32" height="32" rx="7" fill="url(#paint0_linear_2715_6682)"/>
            <path d="M10 15.9797L14.125 20L23 12" stroke="#161B2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_2715_6682" x1="32" y1="-9.77778" x2="-8.62486" y2="-18.5013" gradientUnits="userSpaceOnUse">
                <stop stop-color="#01E2D6"/>
                <stop offset="1" stop-color="#0095FF"/>
            </linearGradient>
            <clipPath id="clip0_2715_6682">
                <rect width="32" height="32" rx="7" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)